class LoginService {
  constructor() {}
  resources = () => ({
    login: {
      uri: `/v1/login`,
      method: ['post']
    },
    loginJob: {
      uri: `/v1/logintrabajador`,
      method: ['post']
    },
    empresas: {
      uri: `/ext/empresas`,
      method: ['get'],
      auth: {
        username: 'HTECUSER',
        password: 'htecurser*_*2020'
      }
    }
  });
}

export default LoginService;
